function FooterDonations() {
    return (
        <a className="social-donation" target="_blank" rel='noreferrer noopener' href="https://www.paypal.me/davideponzini95">
            <i className="fa-solid fa-cocktail"></i>
            Buy me a drink!
            <i className="fa-solid fa-cocktail"></i>
        </a>
    );
}

export default FooterDonations;